import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4dc77f53&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4dc77f53&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dc77f53')) {
      api.createRecord('4dc77f53', component.options)
    } else {
      api.reload('4dc77f53', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4dc77f53&", function () {
      api.rerender('4dc77f53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/views/carbon-template/index.vue"
export default component.exports